import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
// import { GoogleReCaptchaProvider } from '@google-recaptcha/react';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <GoogleReCaptchaProvider
  //   type="v3"
  //   siteKey="6LcHekcpAAAAAGGDUGb9UOU0b5KXiV2DibjifRtG"
  // >
    <BrowserRouter future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>

      <App />

    </BrowserRouter>
  // </GoogleReCaptchaProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
